<template>
  <BaseView title="Alerts">
    <template #content>
      <div class="categories-drawer">
        <CategoriesDrawer
          :on-select-category="onSelectCategory"
          :on-save-alerts="onSaveAlerts"
        />
      </div>

      <div class="alert-list-view">
        <LoadingView v-if="fetchLoading" />
        <ErrorView
          v-else-if="fetchRequestFailed"
          icon="mdi-alert-circle-outline"
          title="No Alerts Found"
          message="An error occurred while fetching alerts."
        />
        <SuccessView v-else />
      </div>
    </template>
  </BaseView>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import CategoriesDrawer from "./components/CategoriesDrawer.vue";
import SuccessView from "./SuccessView.vue";
import LoadingView from "../components/LoadingView.vue";
import ErrorView from "../components/ErrorView.vue";
import BaseView from "../../components/BaseView.vue";

export default {
  name: "FleetAlertsView",
  components: {
    CategoriesDrawer,
    SuccessView,
    LoadingView,
    ErrorView,
    BaseView,
  },
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    ...mapState("fleetAlerts", ["fetchLoading"]),
    ...mapGetters("fleetAlerts", ["fetchRequestFailed"]),
  },
  methods: {
    ...mapActions("fleetAlerts", ["fetchAlerts"]),
    onSelectCategory(categoryId) {
      this.$store.commit("fleetAlerts/SET_SELECTED_CATEGORY", categoryId);
    },
    async onSaveAlerts(alerts) {
      await this.$store.dispatch("fleetAlerts/updateAlerts", alerts);
    },
  },
  watch: {
    async $route(next, previous) {
      const previousVesselName = previous.params.vessel;
      const nextVesselName = next.params.vessel;
      if (previousVesselName != nextVesselName) {
        await this.fetchAlerts(this.$route.params.vessel);
      }
    },
  },
  async mounted() {
    this.$store.commit("fleetAlerts/RESET_STATE");
    await this.fetchAlerts(this.$route.params.vessel);
  },
};
</script>

  <style scoped>
.categories-drawer {
  width: 400px; /* Set a width that fits your needs, adjust as necessary */
  background-color: var(--color-bg);
}

.v-list {
  background-color: var(--color-surface);
}

.v-navigation-drawer {
  background-color: var(--color-surface) !important;
}

/* Ensure the map expands to fill the available space */
.alert-list-view {
  position: absolute;
  left: 400px;
  background-color: var(--color-primary);
  width: calc(100% - 400px);
  height: 100%;
}
</style>
